'use client';

import React from 'react';
import { Button } from '../../ui/button';

/**
 * The "Don't have an account? Register" line and Cancel/Submit row, shared by the two
 * reset-password modals (previously drifting copies). Resolving the error message stays the
 * caller's job; this only owns the markup.
 */
export function RegisterPrompt() {
  return (
    <div className="">
      <p className="cs-s-body-bold mb-2 text-text-default-light">
        Don&apos;t have an account?{' '}
        <a
          href="https://www.contentstack.com/company/contact-us"
          className="text-amethyst-light hover:text-amethyst-light transition-colors underline"
        >
          Register
        </a>
      </p>
    </div>
  );
}

interface AuthModalFooterProps {
  onCancel?: () => void;
  onSubmit: () => void;
  loading?: boolean;
  /** Submit button label; the loading variant replaces it while `loading` is true. */
  submitLabel: string;
  loadingLabel: string;
  /** Trailing icon inside the submit button. Callers that hide it while loading pass null. */
  submitIcon?: React.ReactNode;
  /** Already-resolved message to show under the buttons; falsy renders nothing. */
  error?: string | null;
}

export function AuthModalFooter({
  onCancel,
  onSubmit,
  loading = false,
  submitLabel,
  loadingLabel,
  submitIcon,
  error,
}: AuthModalFooterProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 justify-center">
        <Button
          onClick={onCancel}
          variant="SecondaryFillButton"
          className="w-full sm:w-auto sm:flex-1 cs-button touch-manipulation"
        >
          Return to login
        </Button>
        <Button
          onClick={onSubmit}
          variant="PrimaryFillButton"
          disabled={loading}
          className="w-full sm:w-auto sm:flex-1 text-onAction-strong touch-manipulation flex items-center gap-2"
        >
          <span>{loading ? loadingLabel : submitLabel}</span>
          {submitIcon}
        </Button>
      </div>
      {error && <h6 className="cs-error cs-h6 text-center">{error}</h6>}
    </div>
  );
}
